export default "__VITE_ASSET__BJJfwTg5__"